import { withContextualizedTracking } from 'lib/analytics'
import withReactQueryClientProvider from 'shared/HOC/withReactQueryClientProvider'
import { BabyRegistryChecklist } from './BabyRegistryChecklist'

export default withContextualizedTracking()(
  withReactQueryClientProvider(BabyRegistryChecklist)
)
